export default __webpack_public_path__ + "static/media/cta-phone.4e6b14ec.png";